import type { ITimelogRepository } from '../../domain/repositories/ITimelogRepository';
import { CompositeTimelogRepository } from './CompositeTimelogRepository';
import type { IFaceMatchingRepository } from '../../domain/repositories/IFaceMatchingRepository';
import { FaceMatchingRepository } from './FaceMatchingRepository';
import { CompositeEmployeeLookupRepository, type IEmployeeLookupRepository } from './CompositeEmployeeLookupRepository';
import { LocalEmployeeRepository } from '@/modules/employees/infrastructure/repositories/LocalEmployeeRepository';
import { RemoteEmployeeLookupRepository } from './RemoteEmployeeLookupRepository';

let timelogInstance: ITimelogRepository | null = null;
let faceMatchInstance: IFaceMatchingRepository | null = null;
let employeeLookupInstance: IEmployeeLookupRepository | null = null;
let localEmployeeInstance: LocalEmployeeRepository | null = null;

export function getTimelogRepository(): ITimelogRepository {
  timelogInstance ??= new CompositeTimelogRepository();
  return timelogInstance;
}

export function getFaceMatchingRepository(): IFaceMatchingRepository {
  faceMatchInstance ??= new FaceMatchingRepository();
  return faceMatchInstance;
}

export function getEmployeeLookupRepository(): IEmployeeLookupRepository {
  employeeLookupInstance ??= new CompositeEmployeeLookupRepository(
    new LocalEmployeeRepository(),
    new RemoteEmployeeLookupRepository(),
  );
  return employeeLookupInstance;
}

/** Returns the singleton LocalEmployeeRepository — used for card lookup in CardScanPage. */
export function getLocalEmployeeRepository(): LocalEmployeeRepository {
  localEmployeeInstance ??= new LocalEmployeeRepository();
  return localEmployeeInstance;
}
